import React, { Component, forwardRef } from "react";
import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import axios from "axios";
import { ListItemAvatar, Typography } from "@material-ui/core";
import PrivateComponent from "../Component2/PrivateComponent";
import WS from "../../Config/WS";
import Tabela from "../Tabela/Tabela";
import { AppState } from "../../reducer/ReducerTypes";
import { connect } from "react-redux";
import { SetLinhaProduto } from "../../reducer/ActionsCreator";
import { Store } from "../../reducer/Reducer";
import Component2 from "../Component2/Component2";
import NocRequest from "../../utils/NocRequest";
import { IControllerResult } from "../../controllers/Types";
import { withRouter } from "react-router-dom";
import Tabela2, { ITableQuery } from "../Tabela/Tabela2";

const tableIcons: any = {
    Add: forwardRef((props, ref:any) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref:any) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref:any) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref:any) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref:any) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref:any) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref:any) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref:any) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref:any) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref:any) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref:any) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref:any) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref:any) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref:any) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref:any) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref:any) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref:any) => <ViewColumn {...props} ref={ref} />),
    AddVersao: forwardRef((props, ref:any) => <AddCircleIcon {...props} ref={ref} />),
};

interface IProps {
    appstate?: AppState;
    linhaproduto: string;
    SetLinhaProduto?: (linhaproduto: string) => void;
}

class Versao extends PrivateComponent<IProps, any> {
    constructor(props: any) {
        super(props);
        this.rowClick = this.rowClick.bind(this);
        this.consulta = this.consulta.bind(this);
        this.removerVersao = this.removerVersao.bind(this);
        this.removerVersao1 = this.removerVersao1.bind(this);
    }
    componentDidMountPrivate() {

    }
    rowClick(event: any, rowData: any) {
        //RowClick(event, rowData, this.props.doError);
    }
    async consulta(query: ITableQuery) { 
        let order = (query?.orderBy?.field || 'idversao') + ' ' + (query?.orderDirection || 'desc');
        let search: string = query?.search || '';
        let field: string = query?.field || '';
        let where: string = "";
        where = field == "" ? `
            where  false
            or idversao::text like '%${search.toUpperCase()}%'
            or banco::text like '%${search.toUpperCase()}%'
            or icompany::text like '%${search.toUpperCase()}%'
            or wcompany::text like '%${search.toUpperCase()}%'
            or ipdv::text like '%${search.toUpperCase()}%'
            or imendes::text like '%${search.toUpperCase()}%'
            or ibalanco::text like '%${search.toUpperCase()}%'
            or nfedanfe::text like '%${search.toUpperCase()}%'
            or xboleto::text like '%${search.toUpperCase()}%'
            or nfemonitor::text like '%${search.toUpperCase()}%'
        ` : `
            where  ${field}::text like '%${search.toUpperCase()}%'
        `;
        
        return new Promise<any>(async(resolve, reject) => {
            let result: any = await axios.post(WS.URL_NOC + "entity/sqlpage", {
                sql: `
                    select * from (
                        select idversao, 
                            versao[buscaindice(codigosistema,'banco')] as banco, 
                            versao[buscaindice(codigosistema,'icompany')] as icompany, 
                            versao[buscaindice(codigosistema,'wcompany')] as wcompany, 
                            versao[buscaindice(codigosistema,'ipdv')] as ipdv, 
                            versao[buscaindice(codigosistema,'imendes')] as imendes, 
                            versao[buscaindice(codigosistema,'ibalanco')] as ibalanco, 
                            versao[buscaindice(codigosistema,'nfedanfe')] as nfedanfe, 
                            versao[buscaindice(codigosistema,'xboleto')] as xboleto, 
                            versao[buscaindice(codigosistema,'nfemonitor')] as nfemonitor,
                            versao[buscaindice(codigosistema,'xport')] as xport, 
                            versao[buscaindice(codigosistema,'xpdv')] as xpdv, 
                            versao[buscaindice(codigosistema,'xposto')] as xposto,
                            idsprint, sprint
                        from (
                            select 
                                v.idversao, 
                                array_agg(v.codigosistema) as codigosistema, 
                                array_agg(t.descricao) as sistema, 
                                array_agg(v.linhaproduto) as linhaproduto, 
                                array_agg(v.versao) as versao,
                                max(v.idsprint) as idsprint,
                                max(sp.descricao) as sprint
                            from versoes v
                            left join tiposistema t on (t.linhaproduto,t.codigo)=(v.linhaproduto,v.codigosistema)
                            left join sprint sp on sp.idsprint = v.idsprint
                            where v.linhaproduto = '${this.props.linhaproduto}'
                            group by idversao 
                            order by idversao desc
                        ) as cc 
                    ) as con
                    ${where}
                    order by ${order}               
                `,
                page: query.page,
                pageSize: query.pageSize,
                search: query.search,
                orderBy: ""
            })
            
    
            resolve({
                data: result?.data?.data,
                page: result?.data?.page-1,
                totalCount: result?.data?.total
            });
        })   
    }
    addVersao() {
    }
    removerVersao(idversao: number) {
        this.showConfirm("Confirma a remoção ?", async () => {
            let r: IControllerResult = await NocRequest.post("noc/delversao", {
                linhaproduto: this.props.linhaproduto,
                idversao
            });
            if (this.isOk(r)) {
                this.showAlert("Versão removida com sucesso.", ()=>{
                    this.addRefreshCount();
                });
                
            }
            else
                this.showAlert(this.getMessage(r));
    
        });
    }
    removerVersao1() {

    }
    renderPrivate() {
        
        return (
            <div style={{ maxWidth: "100%", width: '100%' }}>
                <Tabela2
                    // icons={tableIcons}
                    actions={[
                        {
                            icon: <AddCircleIcon/>,
                            isFreeAction: true,
                            //tooltip: "Adicionar uma nova versão",
                            onClick: (data: any) => {
                                //(this.props.SetLinhaProduto as)(this.props.linhaproduto);
                                Store.dispatch(SetLinhaProduto(this.props.linhaproduto));
                                this.redirectTo("/addversao");
                            }
                        },
                        {
                            icon: <DeleteOutline/>,
                            isFreeAction: false,
                            //tooltip: "Remover versão",
                            onClick: (data: any) => {
                                //(this.props.SetLinhaProduto as)(this.props.linhaproduto);
                                this.removerVersao(data.idversao);
                            }
                        },
                    ]}
                    actionBarFreeWidth={2}
                    actionColumnWidth={25}
                    actionsColumns={20}
                    columns={this.props.linhaproduto == "linha1" ? [
                        { title: "ID", field: "idversao" },
                        { title: "Sprint", field: "sprint" },
                        { title: "Banco", field: "banco" },
                        { title: "iCompany", field: "icompany" },
                        { title: "wCompany", field: "wcompany" },
                        { title: "iPDV", field: "ipdv" },
                        { title: "iBalanco", field: "ibalanco" },
                        { title: "NFe DANFE", field: "nfedanfe" },
                        { title: "NFe Monitor", field: "nfemonitor" },
                        { title: "xBoleto", field: "xboleto" },
                        { title: "xPort", field: "xport" },
                        { title: "iMendes", field: "imendes" },
                    ]: [
                        { title: "ID", field: "idversao" },
                        { title: "Sprint", field: "idsprint" },
                        { title: "Banco", field: "banco" },
                        { title: "xPDV", field: "xpdv" },
                        { title: "xPosto", field: "xposto" },
                    ]}
                    fieldsSelect={[
                        "id"
                    ]}
                    data={this.consulta}
                    // options={{
                    //     searchFieldAlignment: 'right',
                    //     minBodyHeight: 'calc(100vh - 200px)',
                    //     maxBodyHeight: 'calc(100vh - 200px)',
                    //     pageSize: 30,
                    //     pageSizeOptions: [9, 20, 30, 50, 100],
                    //     search: true,
                    // }}
                    // search2={true}
                    search={true}
                    pageSize={10}
                    refreshCount={this.state.refreshCount}
                    // onSearchChange={(txt: string) => { console.log(txt); }}
                    // onQueryChange={() => { console.log('query changed') }}

                    title={"Versões dos Sistemas " + (this.props.linhaproduto == "linha1" ? "Linha 1" : "Linha 2")}
                    // localization={{
                    //     header: {
                    //         actions: ""
                    //     }
                    // }}
                />
                {this.baseRender()}
            </div>
        );
    }
}

const mapStateToProps = (state: AppState, ownProps: any) => {
    return {appstate: state, ...ownProps};
}
const mapDisptachToProps = (dispatch: any, ownProps: any) => {
    return {
        ...ownProps,
        SetLinhaProduto: (linhaproduto: string) => dispatch(SetLinhaProduto(linhaproduto)),
    };
}


const mapStateToProps2 = (linhaproduto: string) => (state: AppState, ownProps: any) => {
    return {appstate: state, ...ownProps, linhaproduto};
}


const CVersao = connect(mapStateToProps)(Versao);
export default CVersao;
// export const VersaoLinha1 = () => <CVersao linhaproduto="linha1"/>;
// export const VersaoLinha2 = () => <CVersao linhaproduto="linha2"/>;
export const VersaoLinha1 = connect(mapStateToProps2("linha1"))(Versao);
export const VersaoLinha2 = connect(mapStateToProps2("linha2"))(Versao);
